<div class="cart-item" [ngClass]="compact ? 'cx-compact row' : 'row'">
  <!-- Item Image -->
  <div class="col-3 cx-image-container">
    <a [routerLink]="{ cxRoute: 'product', params: item.product } | cxUrl" cxModal="dismiss" tabindex="-1">
      <cx-media
        [container]="item.product.images?.PRIMARY ? item.product.images?.PRIMARY : item.product.images"
        format="cartIcon"
      ></cx-media>
    </a>
  </div>

  <!-- Item Information -->
  <div class="cx-info col-9">
    <div class="cx-info-container row">
      <!-- Item Description -->
      <div [ngClass]="compact ? '' : ' col'">
        @if (item.product.name) {
          <div class="cx-name">
            <b>
              <a class="cx-link" [routerLink]="{ cxRoute: 'product', params: item.product } | cxUrl" cxModal="dismiss">{{
                item.product.name
              }}</a>
            </b>
            @if (item.product.code) {
              <div class="cx-code">
                {{ 'productSummary.articleNumber' | cxTranslate }} {{ item.product.code }}
              </div>
            }
          </div>
        }
        <!-- Variants -->
        @if (item.product.baseOptions?.length) {
          @for (variant of item.product.baseOptions[0]?.selected?.variantOptionQualifiers; track variant) {
            <div
              class="cx-property"
              >
              @if (variant.name && variant.value) {
                <div class="cx-label">{{ variant.name }}: {{ variant.value }}</div>
              }
            </div>
          }
        }
      </div>
      @if (item.totalPrice && !compact) {
        <div
          class="cx-total cx-total--compact"
          [ngClass]="compact ? '' : ' col-md-auto'"
          >
          <div class="cx-label" [ngClass]="compact ? '' : ' d-block d-md-none d-lg-none d-xl-none'">
            {{ 'cartItems.total' | cxTranslate }}
          </div>
          <div class="cx-value">{{ item.totalPrice.formattedValue }}</div>
        </div>
      }
      <!-- Item Price -->
      @if (item.basePrice) {
        <div
          class="cx-price"
          [ngClass]="compact ? 'cx-price--compact' : ' col-md-12 col-lg-12 justify-content-start'"
          >
          <div class="cx-label" [ngClass]="compact ? '' : 'col-2 no-padding'">
            {{ 'cartItems.itemPrice' | cxTranslate }}
          </div>
          @if (item.basePrice) {
            <div class="cx-value" [ngClass]="compact ? '' : 'col-11'">
              {{ item.basePrice?.formattedValue }}
            </div>
          }
        </div>
      }
      <!-- Item UOM -->
      @if (uomName) {
        <div class="cx-UOM" [ngClass]="compact ? '' : 'block col-md-3 col-lg-2 justify-content-start'">
          <div class="cx-label" [ngClass]="compact ? '' : ' d-block d-md-none d-lg-none d-xl-none'">
            Unit of measurement
          </div>
          @if (uomName) {
            <div class="cx-value">
              {{ uomName }}
            </div>
          }
        </div>
      }

      <!-- Item Quantity -->
      <div class="cx-quantity" [ngClass]="compact ? '' : ' col-md-12 col-lg-12 justify-content-start'">
        <div
          class="cx-label"
          [ngClass]="compact ? '' : 'col-2 no-padding'"
          placement="left"
          title="{{ 'cartItems.quantityTitle' | cxTranslate }}"
          >
          {{ 'cartItems.quantity' | cxTranslate }}
        </div>
        <div class="cx-value" [ngClass]="compact ? '' : 'col-11'">
          <cx-item-counter
            [control]="quantityControl"
            [readonly]="!item.updateable || readonly || options.isSaveForLater"
            [max]="maxQuantity"
            [allowZero]="true"
            >
          </cx-item-counter>
          <div>
            @if (showAllStatus) {
              <div
                class="cx-in-stock"
                [ngClass]="compact ? '' : 'block no-padding col-12 col-xs-12 col-md-12 col-lg-12 col-xl-12'"
                >
                <div class="cx-label no-padding stock-status">
                  <span class="info" [ngClass]="getStockColor(item.product)">
                    {{ 'addToCart.' + item.product.stock.stockLevelStatus | cxTranslate }}
                  </span>
                  <i
                    class="stock-icon fas"
                    [ngClass]="[getStockColor(item.product), getStockIcon(item.product)]"
                    [title]="'addToCart.' + item.product.stock.stockLevelStatus | cxTranslate"
                    [attr.aria-label]="'addToCart.' + item.product.stock.stockLevelStatus | cxTranslate"
                  ></i>
                </div>
              </div>
            } @else {
              @if (item.product.stock.stockLevelStatus === 'outOfStock') {
                <div
                  class="cx-in-stock"
                  [ngClass]="compact ? '' : 'block no-padding col-12 col-xs-12 col-md-12 col-lg-12 col-xl-12'"
                  >
                  <div class="cx-label no-padding stock-status">
                    <span class="info out-of-stock">
                      {{ 'addToCart.' + item.product.stock.stockLevelStatus | cxTranslate }}
                    </span>
                    <i
                      class="stock-icon fas fa-exclamation-circle out-of-stock"
                      [title]="'addToCart.' + item.product.stock.stockLevelStatus | cxTranslate"
                      [attr.aria-label]="'addToCart.' + item.product.stock.stockLevelStatus | cxTranslate"
                      >
                    </i>
                  </div>
                </div>
              }
            }

          </div>
        </div>
      </div>

      <!-- Full Pallet -->
      @if (showFullPallet) {
        @if (fullPallet$ | async; as fullPallet) {
          <div
            class="container full-pallet mt-3"
            [ngClass]="compact ? 'p-0' : ''"
            >
            <div class="row">
              <div [ngClass]="compact ? 'col pr-2' : 'col'">
                <button
                  type="button"
                  class="btn btn-primary w-100"
                  [disabled]="isFullPallet"
                  [ngStyle]="{ 'white-space': compact ? 'pre-line' : '' }"
                  (click)="updateToFullPallet(fullPallet.numberOfUOMforFullPallet, quantityControl.value)"
                  >
                  {{ 'cartItems.updateToFullPallet' | cxTranslate: { fullPallet: fullPallet.numberOfUOMforFullPallet } }}
                </button>
                <small>
                  {{ 'cartItems.numberOfUOMperPallet' | cxTranslate: { fullPallet: fullPallet.numberOfUOMperPallet } }}
                </small>
              </div>
              <div [ngClass]="compact ? 'col pl-2' : 'col'">
                <button
                  type="button"
                  class="btn btn-primary w-100"
                  [disabled]="isFullLayer"
                  [ngStyle]="{ 'white-space': compact ? 'pre-line' : '' }"
                  (click)="addPalletLayer(fullPallet.numberOfUOMforFullLayer, quantityControl.value)"
                  >
                  {{ 'cartItems.updateToFullLayer' | cxTranslate: { fullLayer: fullPallet.numberOfUOMforFullLayer } }}
                </button>
                <small>
                  {{ 'cartItems.numberOfUOMperLayer' | cxTranslate: { fullLayer: fullPallet.numberOfUOMperLayer } }}
                </small>
              </div>
            </div>
          </div>
        }
      }

      <!-- ETA -->
      @if (item?.orderEntryEstimatedDeliveryDate) {
        <div
          class="cx-ETA"
          [ngClass]="compact ? 'cx-ETA--compact' : ' col-md-12 col-lg-12 justify-content-start'"
          >
          <div class="cx-label" [ngClass]="compact ? '' : 'col-2 no-padding'">
            {{ 'orderHistory.inStockFrom' | cxTranslate }}
          </div>
          <div class="cx-value" [ngClass]="compact ? '' : 'col-11'">
            {{ item?.orderEntryEstimatedDeliveryDate | cxDate }}
          </div>
        </div>
      }
      <!-- Status -->
      @if (item?.orderEntryStatusDisplay) {
        <div
          class="cx-status"
          [ngClass]="compact ? '' : ' col-md-12 col-lg-12 justify-content-start'"
          >
          <div class="cx-label" [ngClass]="compact ? '' : 'col-2 no-padding '">
            {{ 'orderHistory.status' | cxTranslate }}
          </div>
          <div class="cx-value" [ngClass]="compact ? '' : 'col-11'">
            {{ isCancelling ? ('orderDetails.statusDisplay_CANCELLING' | cxTranslate) : item?.orderEntryStatusDisplay }}
          </div>
        </div>
      }
      <!-- Total -->
      @if (options.isSaveForLater) {
        <div class="cx-total" [ngClass]="compact ? '' : ' col-md-12 col-lg-12 justify-content-end'">
          <div class="cx-label" [ngClass]="compact ? '' : ' d-block d-md-none d-lg-none d-xl-none'">
            {{ 'saveForLaterItems.stock' | cxTranslate }}
          </div>
          @if (item.product?.stock?.stockLevel >= 0) {
            <div class="cx-value">
              {{ item.product.stock.stockLevel }}
            </div>
          } @else {
            <div class="cx-value">
              {{ 'saveForLaterItems.forceInStock' | cxTranslate }}
            </div>
          }
        </div>
      } @else {
        @if (item.totalPrice && compact) {
          <div class="cx-total" [ngClass]="compact ? '' : ' col-md-12 col-lg-12'">
            <div class="cx-label" [ngClass]="compact ? '' : ' d-block d-md-none d-lg-none d-xl-none'">
              {{ 'cartItems.total' | cxTranslate }}
            </div>
            <div class="cx-value">{{ item.totalPrice.formattedValue }}</div>
          </div>
        }
      }

      <!-- Cancel Item -->
      @if (showCancel) {
        <div class="col-auto mt-3">
          <button (click)="itemCancel.emit()" [disabled]="disableOnCancel" class="btn btn-danger btn-small">
            @if (showSpinner) {
              <i class="fa fa-spinner fa-spin"></i>
            }
            Cancel Item
          </button>
        </div>
      }
    </div>

    <!-- Promotion -->
    @if (appliedProductPromotions$ | async; as appliedProductPromotions) {
      <cx-promotions [promotions]="appliedProductPromotions"></cx-promotions>
    }

    <!-- Actions -->
    @if ((!readonly || options.isSaveForLater) && item.updateable) {
      <div class="cx-actions col-12">
        @if (!isProductOutOfStock(item.product)) {
          <ng-container
          *ngTemplateOutlet="
            options.optionalBtn;
            context: {
              $implicit: { loading: quantityControl.disabled, item: item }
            }
          "
        ></ng-container>
      }
      <div class="col-md-3 no-padding cx-remove-btn">
        <!-- <button class="link cx-action-link" [disabled]="quantityControl.disabled" (click)="removeItem()">
        {{ 'common.remove' | cxTranslate }}
      </button> -->
      <button class="link cx-action-link" (click)="removeItem()">
        {{ 'common.remove' | cxTranslate }}
      </button>
    </div>
  </div>
}
</div>
</div>

